/**
 * 答题详情
 * @description 答题详情组件
 * @author yly
 * @date 2023-10-13
 */
import React from 'react';
import '@/styles/components/exam/examPreviw/index.less'
import {secondsFormatDate} from '@/utils/dateUtil'
import { component_tool } from '../../../tool'
let {
  WizComponent,
  WizLayout,
  WizRow,
  WizCol,
  WizTypography,
  WizButton,
  WizList,
  WizRadio,
  WizCheckbox,
  WizInput,
  WizDivider
} = component_tool;
import './index.less'
const { Header, Content } = WizLayout;
const { Title, Text, Paragraph } = WizTypography
export default class ExamPaperPreview extends WizComponent {

  constructor(props) {
    super(props);
    this.state = {
    }
    this.data = props['data']
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps['data']) {
      this.data = nextProps['data']
      return true
    }
    else {
      return false
    }
  }


  /**
   * col各个屏幕大小的适配
   */
  colFree(xs, sm, md, lg, xl, xxl) {
    let size = {
    };
    if (xs) {
      size["xs"] = xs
    }
    if (sm) {
      size["sm"] = sm
    }
    if (md) {
      size["md"] = md
    }
    if (lg) {
      size["lg"] = lg
    }
    if (xl) {
      size["xl"] = xl
    }
    if (xxl) {
      size["xxl"] = xxl
    }
    return size;
  }

  /**
   * 考试标题
   */
  _title = () => {
    let { detail = {} } = this.data
    let { id = '', practiceName = '' } = detail
    if (id) {
      return (
        <WizRow className='exam_title' type={'flex'} justify={'center'} align={'middle'}>
          <Title level={4} ellipsis>{practiceName}</Title>
        </WizRow>
      )
    } else {
      return null
    }
  }

  /**
   * 考试信息
   */
  _info = () => {
    let { detail = {} } = this.data
    let { id = '', fullName = '', userName = '', correctNum = '', accuracy = '', duration = '', errorNum = '', noNum = '', questionNum = '', } = detail
    if (id) {
      return (
        <div className='illustrate-out-box'>
          <div className='illustrate-fixed-box'>试卷说明</div>
          <WizRow className='illustrate-line'>
            <WizCol span={8}>
              <span className='illustrate-title'>姓名：</span>
              <span className='illustrate-value'>{fullName}</span>
            </WizCol>
            <WizCol span={8}>
              <span className='illustrate-title'>账号：</span>
              <span className='illustrate-value'>{userName}</span>
            </WizCol>
            <WizCol span={8}>
              <span className='illustrate-title'>答题时长：</span>
              <span className='illustrate-value'>{secondsFormatDate(duration)}</span>
            </WizCol>
          </WizRow>
          <WizRow className='illustrate-line'>
            <WizCol span={8}>
              <span className='illustrate-title'>答对：</span>
              <span className='illustrate-value'>{correctNum}题</span>
            </WizCol>
            <WizCol span={8}>
              <span className='illustrate-title'>未答：</span>
              <span className='illustrate-value'>{noNum}题</span>
            </WizCol>
            <WizCol span={8}>
              <span className='illustrate-title'>答错：</span>
              <span className='illustrate-value'>{errorNum}题</span>
            </WizCol>
          </WizRow>
          <WizRow className='illustrate-line'>
            <span className='illustrate-title'>正确率：</span>
            <span className='illustrate-value'>{accuracy}%</span>
          </WizRow>
        </div>
      )
    } else {
      return null
    }

  }

  /**
   * 锚点跳转方法
   */
  scrollToAnchor = (anchorName) => {
    if (anchorName) {
      let anchorElement = document.getElementById(anchorName);
      if (anchorElement) { anchorElement.scrollIntoView(); }
    }
  }

  /**
   * 章节
   */
  _part = (index) => {
    let part = this.data
    return (
      <div key={part['id']} id={part['id']} type={'flex'}>
        {/* {part?.description ? <Paragraph level={2}><div style={{ overflow: 'hidden', overflowX: 'scroll' }} dangerouslySetInnerHTML={{ __html: part?.description }} /></Paragraph> : null} */}
        {this._questions(part['questions'])}
      </div>
    )
  }

  /**
   * 问题内容
   */
  _questions = (questions = []) => {
    let r = []
    for (let index = 0; index < questions.length; index++) {
      const question = questions[index];
      r.push(
        <WizList
          className='question-item'
          key={'question_' + question['id']}
          rowKey='id'
          locale={{ emptyText: ' ' }}
          header={this._questionTitle(question, index)}
          footer={this._quetionAnswer(question)}
          dataSource={question['options'] || []}
          renderItem={this._renderItem}
          itemLayout={'vertical'}
          split={false}
          size={'small'}
        />
      )
    }

    return r
  }

  _renderItem = (item, index) => {
    let _index = String.fromCharCode(index + 65) + '、'
    let img = item['img'] && item['img'] != '' ? <img src={getOssFilePath(item['img'])} className='question_img' /> : null
    return (
      <div >
        <Paragraph key={'name'}>
          {_index + item['name'] || ''}
        </Paragraph>
        <div key={'img-div'}>{img}</div>
      </div>
    )
  }


  /**
   * 题干
   */
  _questionTitle = (question, index) => {
    let { title, img, type } = question
    let r = [
      <Paragraph key={'_questionTitle'} strong>
        <Text className='question_title_number'>{index + 1}</Text>
        <span className='question_title_text'>{title}</span>
      </Paragraph>,
      <> {type != 2 ? <WizDivider key={question['id'] + 'dashed'} dashed /> : null}</>,

    ]
    if (img && img != '') {
      r.push(<img key={'_questionTitleImg'} src={getOssFilePath(img)} className='question_img' />)
    }
    if (type === 3) {
      r.push(
        <WizInput className={'exam-preview-input'} key={'_questionTitleWizInput'} disabled defaultValue='请输入答案' />
      )
    } else if (type === 4) {
      r.push(
        <WizInput.TextArea className={'exam-preview-input'} key={'_questionTitleWizInputTextArea'} disabled defaultValue='请输入答案' />
      )
    }
    return r
  }

  /**
   * 问题答案部分
   */
  _quetionAnswer = (question) => {
    let { correctAnswer, answer, answerAnalysis, type, options = [] } = question
    let _correct = ''
    let _answer = ''
    if (type == 2) {
      _correct = [<Text key='answer'>正确答案： </Text>, correctAnswer ? correctAnswer === '0' ? '正确' : '错误' : '']
      _answer = [<Text key='answer'>我的答案： </Text>, answer ? answer === '0' ? '正确' : '错误' : '']
    } else {
      _correct = [<Text key='answer'>正确答案： </Text>, correctAnswer?.split(",").map(p => parseInt(p)).map(p => String.fromCharCode(p + 65)).join(', ')]
      _answer = [<Text key='answer'>我的答案： </Text>, answer?.split(",").map(p => parseInt(p)).map(p => String.fromCharCode(p + 65)).join(', ')]
    }
    let style = options.length > 0 || type === 1 ? {} : { marginTop: -40, }
    return (
      <div style={style}>
        {[
          <WizDivider key={question['id'] + 'dashed'} dashed />,
          <div className='answer-box'>
            <WizRow className='answer-line'>
              <WizCol span={8}>
                <Paragraph key={question['id'] + 'correct'}>{_correct}</Paragraph>
              </WizCol>
              <WizCol span={16}>
                <Paragraph key={question['id'] + 'correct'}>{_answer}</Paragraph>
              </WizCol>
            </WizRow>
            <Paragraph key={question['id'] + 'analysis'}><Text>答案解析：  </Text>{answerAnalysis && answerAnalysis != '' ? answerAnalysis : '暂无解析'}</Paragraph>
          </div>
        ]}
      </div>
    )
  }

  render() {
    console.log(this.data, 'data')
    return (
      <WizLayout className="full-layout practice-answer-details">
        <Header>
          {this._title()}
          {this._info()}
        </Header>
        <Content className='exam-preview-content'>
          {this._part()}
        </Content>
      </WizLayout>
    )

  }
}

/**
 * 默认值
 */
ExamPaperPreview.defaultProps = {
}

/**
 * props入参校验
 */
ExamPaperPreview.propTypes = {
}
